import { Button, Dialog, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';
import { Edit, Search } from '../../components/icons';
import { FunctionComponent, useEffect, useState } from "react";
import liteApi from '../../api/lite';
import { Typography } from '../../tailwindcomponents';
import LiteHandoverDialogContext from './LiteHandoverDialogContext';
import { AllLiteHandoverReports, LiteHandoverReportInformation } from '../../types/lite';
import { SearchTailAndIssue } from '../../components/RVKLite';

type LiteHandoverProps = {
    allTails: Array<string>,
    workPlace: string,
    setLoading: Function
}

const LiteHandover: FunctionComponent<LiteHandoverProps> = ({ allTails, workPlace, setLoading }) => {
    const store = useSelector((state: RootState) => state);
    const accessGroups = store.user.me.user_clearence_groups;
    const isLiteSupervisorAdmin =
        accessGroups.includes("Lite Edit") ||
        accessGroups.includes("Rvk Line Edit") ||
        accessGroups.includes("Rvk Line Edit");
    const [reports, setReports] = useState<AllLiteHandoverReports[]>([]);
    const [handoverDialogOpen, setHandoverDialogOpen] = useState<boolean>(false);
    const [liteHandoverReport, setLiteHandOverReport] = useState<LiteHandoverReportInformation | null>(null);
    const [searchIssue, setSearchIssue] = useState<string>("");
    const [searchTail, setSearchTail] = useState<string>("");

    useEffect(() => {
        refreshHandOverTab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const refreshHandOverTab = () => {
        setLoading(true);
        liteApi.GetAllLiteHandOverReports(workPlace).then(res => {
            setReports(res.data);
            setLoading(false);
        });
    };

    const refresh = (reportId: number) => {
        setLoading(true);
        liteApi.GetLiteHandoverReportByID(reportId).then(res => {
            if (res.status === true) {
                setLiteHandOverReport(res.data);
                setHandoverDialogOpen(true);
            }
            setLoading(false);
        });
    };

    const onCreateNewHandoverReport = () => {
        setLoading(true);
        liteApi.CreateNewLiteHandoverReport(workPlace).then(res => {
            if (res.status === false) {
                if (res.message !== null) {
                    alert(res.message);
                }else{
                    alert(`{Something went wrong, was not able to create a ${workPlace === 'RVK' ? "RVK Line" : "Lite"} handover}`);
                }
            } else {
                refresh(res.data);
                refreshHandOverTab();
            }
            setLoading(false);
        });
    };

    const onClickRow = (reportId: number) => {
        refresh(reportId);
    };

    const generateTableBody = (row: AllLiteHandoverReports, index: number) => {
        return (
            <TableRow >
                <TableCell>{row.created_date_text}</TableCell>
                <TableCell>{row.supervisor_name}</TableCell>
                <TableCell>{row.begin_date_text}</TableCell>
                <TableCell>{row.end_date_text}</TableCell>
                <TableCell>{row.issues_count}</TableCell>
                <TableCell>{row.employees_count}</TableCell>
                <TableCell>
                    {row.is_submitted && <Search className="cursor-pointer" onClick={() => onClickRow(row.id)} color='primary' />}
                    {!row.is_submitted && <Edit onClick={() => onClickRow(row.id)} color='primary' className="cursor-pointer" />}
                </TableCell>
            </TableRow>
        );
    };

    const getHandoversBySearch = () => {
        liteApi.GetHandoverBySearchFilters(workPlace, searchIssue, searchTail).then(res => {
            setReports(res.data);
        });
    };

    const closeDialog = () => {
        setHandoverDialogOpen(false);
        setLiteHandOverReport(null); // ensure child is never rendered with null next time
    };

    return (
        <div className="p-3">
            <Typography
                variant={'h1'}
                align={'center'}
                text={workPlace === "RVK" ? "Reykjavík Line Handover" : "Supervisor handover reports"}
            />
            <SearchTailAndIssue
                searchIssue={searchIssue}
                searchTail={searchTail}
                setSearchTail={setSearchTail}
                setSearchIssue={setSearchIssue}
                getHandoversBySearch={getHandoversBySearch}
                refreshHandOverTab={refreshHandOverTab}
            />

            {!(reports.filter(s => !s.is_submitted).length > 0) && isLiteSupervisorAdmin && (
                <Button variant="text" color='primary' onClick={() => onCreateNewHandoverReport()}>
                    Create new
                </Button>
            )}

            <Table
                headers={["Created", "Created By", "start", "end", "Issues", "Employees", "Submitted"]}
                rows={reports}
                generateBody={(row: AllLiteHandoverReports, index: number) => generateTableBody(row, index)}
                defaultRowsPerPage={25}
                pagination={true}
                skipIndexCol={true}
            />

            {handoverDialogOpen && liteHandoverReport && (
                <Dialog
                    visible={true}
                    max_width={"xl"}
                    strict={false}
                    show_options={false}
                    onClose={closeDialog}
                    title={
                        liteHandoverReport.is_submitted === true
                            ? (workPlace === "RVK" ? "RVK Line Handover" : "Supervisor Handover")
                            : (workPlace === "RVK" ? "Create new RVK Line Handover" : "Create new Supervisor Handover")
                    }
                    context={
                        <LiteHandoverDialogContext
                            isEditMode={isLiteSupervisorAdmin}
                            workPlace={workPlace}
                            refreshLiteHandOverTab={refreshHandOverTab}
                            allTails={allTails}
                            liteHandoverReport={liteHandoverReport}
                            refresh={(id: number) => refresh(id)}
                            onClose={() => setHandoverDialogOpen(false)}
                        />
                    }
                />
            )}
        </div>
    );
};

export default LiteHandover;



